// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var DOM__Event$SmartcutsMacros = require("../DOM__Event.bs.js");
var EmailLabel$SmartcutsMacros = require("./shared/EmailLabel.bs.js");
var ClickCommand$SmartcutsMacros = require("./ClickCommand.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var OAuthProvider$SmartcutsMacros = require("../OAuthProvider.bs.js");
var DataDependency$SmartcutsMacros = require("./shared/DataDependency.bs.js");
var ViewportPosition$SmartcutsMacros = require("./shared/ViewportPosition.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "eventSrc",
                Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_encode, v.eventSrc)
              ],
              [
                "oauthProvider",
                OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
              ],
              [
                "clickOnElement",
                Selector$SmartcutsMacros.selector_encode(v.clickOnElement)
              ],
              [
                "emailLabel",
                EmailLabel$SmartcutsMacros.t_encode(Decco.stringToJson, v.emailLabel)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var eventSrc = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
  if (eventSrc.TAG === /* Ok */0) {
    var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
    if (oauthProvider.TAG === /* Ok */0) {
      var clickOnElement = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickOnElement"), null));
      if (clickOnElement.TAG === /* Ok */0) {
        var emailLabel = EmailLabel$SmartcutsMacros.t_decode(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "emailLabel"), null));
        if (emailLabel.TAG === /* Ok */0) {
          var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
          if (viewportPosition.TAG === /* Ok */0) {
            var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
            if (positionRelToElement.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        eventSrc: eventSrc._0,
                        oauthProvider: oauthProvider._0,
                        clickOnElement: clickOnElement._0,
                        emailLabel: emailLabel._0,
                        viewportPosition: viewportPosition._0,
                        positionRelToElement: positionRelToElement._0
                      }
                    };
            }
            var e = positionRelToElement._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".positionRelToElement" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = viewportPosition._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".viewportPosition" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = emailLabel._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".emailLabel" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = clickOnElement._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".clickOnElement" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = oauthProvider._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".oauthProvider" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = eventSrc._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".eventSrc" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stringify(param) {
  return "{ oauthProvider: " + (OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider) + (", clickOnElement: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.clickOnElement) + (", emailLabel: " + (EmailLabel$SmartcutsMacros.stringify((function (x) {
                          return x;
                        }), param.emailLabel) + ", viewportPosition, positionRelToElement }")))));
}

function maybeForTargetElement(eventSrc, oauthProvider, clientX, clientY, positionRelToElement, targetElement) {
  var clickOnElement = Selector$SmartcutsMacros.forDomElement(targetElement);
  var firstElementWithEmailThatHasMostOccurrencies = function (elements) {
    if (elements.length === 1) {
      return elements[0];
    }
    var elementsByEmail = Belt_Array.reduce(elements, undefined, (function (elementsByEmail, element) {
            var email = element.innerText;
            var otherElements = Belt_MapString.get(elementsByEmail, email);
            return Belt_MapString.set(elementsByEmail, email, otherElements !== undefined ? Belt_Array.concat(otherElements, [element]) : [element]);
          }));
    var arg = Belt_MapString.toArray(elementsByEmail);
    var match = (function (param) {
          return ArrayUtils$SmartcutsMacros.splitAtFirstExn(param, arg);
        })("Expect to get emails when calculating firstElementWithEmailThatHasMostOccurrencies");
    var match$1 = Belt_Array.reduce(match[1], match[0], (function (currentEmailHasMostOccurrenciesWithElements, emailWithElements) {
            if (emailWithElements[1].length > currentEmailHasMostOccurrenciesWithElements[1].length) {
              return emailWithElements;
            } else {
              return currentEmailHasMostOccurrenciesWithElements;
            }
          }));
    return Caml_array.get(match$1[1], 0);
  };
  return Belt_Option.map(EmailLabel$SmartcutsMacros.LocateEmailElements.forDomElement(targetElement), (function (emailElements) {
                var match;
                match = typeof emailElements === "number" ? [
                    targetElement,
                    targetElement
                  ] : (
                    emailElements.TAG === /* Children */0 ? [
                        targetElement,
                        firstElementWithEmailThatHasMostOccurrencies(emailElements._0)
                      ] : [
                        emailElements._0,
                        firstElementWithEmailThatHasMostOccurrencies(emailElements._1)
                      ]
                  );
                var emailElement = match[1];
                return {
                        eventSrc: eventSrc,
                        oauthProvider: oauthProvider,
                        clickOnElement: clickOnElement,
                        emailLabel: {
                          emailText: emailElement.innerText,
                          elementWithEmailText: Selector$SmartcutsMacros.forDomElement(emailElement),
                          sharedRootDepth: DOM__Element$SmartcutsMacros.getDepthRelativeToBody(match[0])
                        },
                        viewportPosition: {
                          clientX: clientX,
                          clientY: clientY
                        },
                        positionRelToElement: positionRelToElement
                      };
              }));
}

function maybeFromClickEvent(eventSrc, oauthProvider, clickEvent) {
  var targetElement = clickEvent.target;
  if (targetElement.tagName === "INPUT") {
    return ;
  }
  var clientX = clickEvent.clientX | 0;
  var clientY = clickEvent.clientY | 0;
  var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.fromMouseEvent(clickEvent);
  return maybeForTargetElement(eventSrc, oauthProvider, clientX, clientY, positionRelToElement, targetElement);
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  maybeForTargetElement: maybeForTargetElement,
  maybeFromClickEvent: maybeFromClickEvent
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "oauthProvider",
                OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
              ],
              [
                "clickOnElement",
                Selector$SmartcutsMacros.selector_encode(v.clickOnElement)
              ],
              [
                "emailLabel",
                EmailLabel$SmartcutsMacros.t_encode(DataDependency$SmartcutsMacros.DataRef.t_encode, v.emailLabel)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
  if (oauthProvider.TAG === /* Ok */0) {
    var clickOnElement = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickOnElement"), null));
    if (clickOnElement.TAG === /* Ok */0) {
      var emailLabel = EmailLabel$SmartcutsMacros.t_decode(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "emailLabel"), null));
      if (emailLabel.TAG === /* Ok */0) {
        var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
        if (viewportPosition.TAG === /* Ok */0) {
          var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
          if (positionRelToElement.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      oauthProvider: oauthProvider._0,
                      clickOnElement: clickOnElement._0,
                      emailLabel: emailLabel._0,
                      viewportPosition: viewportPosition._0,
                      positionRelToElement: positionRelToElement._0
                    }
                  };
          }
          var e = positionRelToElement._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".positionRelToElement" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = viewportPosition._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".viewportPosition" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = emailLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".emailLabel" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = clickOnElement._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".clickOnElement" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = oauthProvider._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".oauthProvider" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function stringify$1(param) {
  return "{ oauthProvider: " + (OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider) + (", clickOnElement: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.clickOnElement) + (", emailLabel: " + (EmailLabel$SmartcutsMacros.stringify(DataDependency$SmartcutsMacros.DataRef.stringify, param.emailLabel) + ", viewportPosition, positionRelToElement }")))));
}

function updateSelector(f, cmdVal) {
  var init = cmdVal.emailLabel;
  return {
          oauthProvider: cmdVal.oauthProvider,
          clickOnElement: Curry._1(f, cmdVal.clickOnElement),
          emailLabel: {
            emailText: init.emailText,
            elementWithEmailText: Curry._1(f, cmdVal.emailLabel.elementWithEmailText),
            sharedRootDepth: init.sharedRootDepth
          },
          viewportPosition: cmdVal.viewportPosition,
          positionRelToElement: cmdVal.positionRelToElement
        };
}

function getInputIdentifier(param) {
  return "OAuth via " + OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider);
}

function fromRecording(param) {
  var match = param.emailLabel;
  return {
          oauthProvider: param.oauthProvider,
          clickOnElement: param.clickOnElement,
          emailLabel: {
            emailText: {
              TAG: /* StaticText */0,
              _0: match.emailText
            },
            elementWithEmailText: match.elementWithEmailText,
            sharedRootDepth: match.sharedRootDepth
          },
          viewportPosition: param.viewportPosition,
          positionRelToElement: param.positionRelToElement
        };
}

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  updateSelector: updateSelector,
  getInputIdentifier: getInputIdentifier,
  fromRecording: fromRecording
};

var t_encode$2 = t_encode$1;

var t_decode$2 = t_decode$1;

function selectorGet(param) {
  return [
          param.clickOnElement,
          param.emailLabel.elementWithEmailText
        ];
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$1,
  selectorGet: selectorGet
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

exports.CommandValue = CommandValue;
/* Selector-SmartcutsMacros Not a pure module */
